module.exports = __webpack_public_path__ + "img/06.5aa6b392.png";